import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import {Paper} from "@mui/material";
import OrganisationUserContractPartForm from "../../../Components/Forms/Pages/HR/OrganisationUserContractPart/OrganisationUserContractPartForm";
import { useSelector } from "react-redux";
import { editOrganisationUserContractPart } from "../../../Services/HR/OrganisationUserContractPartService";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'year': {required: true},
    'month': {required: true},
    'net': {required: true},
    'paymentDate': {required: true},
    'gross': {required: true}
}

const EditOrganisatioUserContractPart = (props) => {
    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.organisationUserContractPart.editOrganisationUserContractPart.pageTitle);
    });

    const onSubmit = (data) => {
        setShowLoader(true);

        editOrganisationUserContractPart(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        })
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <OrganisationUserContractPartForm
                formRules={formRules}
                values={getValues()} setValue={setValue}
                data={data} errors={errors} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}

export default EditOrganisatioUserContractPart;